import Vue from 'vue'

import {
  Button,
  Select,
  Option,
  Progress,
  Input,
  Table,
  TableColumn,
  Dialog,
  Form,
  FormItem,
  Tag,
  Tabs,
  TabPane,
  Menu,
  MenuItem,
  Submenu,
  Upload,
  Pagination,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Checkbox,
  Tooltip,
  Divider,
  DatePicker,
  Collapse,
  CollapseItem,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Badge,
  Alert,
  MessageBox,
} from 'element-ui'

// element多语言
// element -> https://element.eleme.cn/#/zh-CN/component/i18n
import locale from 'element-ui/lib/locale'
import '../styles/element-variables.scss'
import { loadLocale } from '@/locales'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
const elementLocales = {
  zh: zhLocale,
  en: enLocale,
}
locale.use(elementLocales[loadLocale()])

// 全局提示组件
Vue.component(Message)
Vue.prototype.$message = Message
Vue.component(MessageBox)
Vue.prototype.$msgbox = MessageBox

Vue.use(Button)
Vue.use(Select).use(Option)
Vue.use(Progress)
Vue.use(Input)
Vue.use(Table).use(TableColumn)
Vue.use(Dialog)
Vue.use(Form).use(FormItem)
Vue.use(Tag)
Vue.use(Tabs).use(TabPane)
Vue.use(Menu).use(MenuItem).use(Submenu)
Vue.use(Upload)
Vue.use(Pagination)
Vue.use(Dropdown).use(DropdownMenu).use(DropdownItem)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(Tooltip)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Badge)
Vue.use(Alert)
